import Vue from 'vue';
import VueRouter from 'vue-router';
import Start from '../views/Start';

Vue.use(VueRouter);

const routes = [
  {
    path: '/:userId/:roomId/:token',
    name: 'Start',
    component: Start,
    props: true
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
